import { all, call, fork, put, select, takeEvery } from 'redux-saga/effects';
import { RESET_PASSWORD, SIGNIN_USER, SIGNOUT_USER } from 'constants/ActionTypes';
import { fetchResource, showErrorMessage } from 'helpers/utilHelpers';
import {
  resetPasswordError,
  resetPasswordSuccess,
  setAuthData,
  userSignInError,
  userSignInSuccess,
  userSignOutSuccess,
} from 'actions/authActions';
import { authTokenSelector } from 'selectors/authSelectors';
import { hideLoader } from 'actions/settingActions';
import { deleteCookie, setCookie } from 'helpers/cookieHelpers';
import { AUTH_COOKIE } from 'constants/UtilConstants';
import { unsubscribeOnline } from 'actions/entities/userActions';
import { unsubscribeNewFeed } from 'actions/ui/notificationDrawerActions';
import { unsubscribeTimerStarted, unsubscribeTimerStopped } from 'actions/ui/timerActions';

function* loginUser(action) {
  try {
    const { username, password } = action.user;
    const response = yield call(() =>
      fetchResource('auth/tokens', 'POST', {
        username: username,
        password: password,
      }),
    );

    yield put(setAuthData(response));
    setCookie(AUTH_COOKIE, response.token, 10 * 365 * 24 * 60 * 60);

    yield put(userSignInSuccess(response));

    yield put(hideLoader());
  } catch (response) {
    const data = yield response.json();
    if (response.status && response.status === 422) {
      yield put(userSignInError(data));
      yield put(hideLoader());
      return;
    }

    yield showErrorMessage('Error occurred');
    yield put(hideLoader());
  }
}

function* logoutUser() {
  try {
    const token = yield select(authTokenSelector);
    yield call(() => fetchResource('auth/tokens/' + token, 'DELETE'));

    deleteCookie(AUTH_COOKIE);
    localStorage.removeItem('authToken');

    yield put(unsubscribeOnline());
    yield put(unsubscribeNewFeed());
    yield put(unsubscribeTimerStarted());
    yield put(unsubscribeTimerStopped());
    yield put(userSignOutSuccess());
  } catch (e) {
    yield showErrorMessage('Error occurred');
  }
}

function* resetPassword(action) {
  try {
    yield call(() => fetchResource('users/reset-password', 'POST', action.email));
    yield put(resetPasswordSuccess(action.email));
    yield put(hideLoader());
  } catch (e) {
    const data = yield e.json();
    yield put(resetPasswordError(data));
    yield put(hideLoader());
  }
}

function* authReset() {
  yield takeEvery(RESET_PASSWORD, resetPassword);
}

function* authLogin() {
  yield takeEvery(SIGNIN_USER, loginUser);
}

function* authLogout() {
  yield takeEvery(SIGNOUT_USER, logoutUser);
}

export default function* rootSaga() {
  yield all([fork(authLogin), fork(authLogout), fork(authReset)]);
}
